import React, { FC } from 'react';
import cn from 'classnames';
import BackButton from '../BackButton';
import CategoriesList, { CATEGORY_LIST_VIEW_TYPES } from '../CategoriesList';

import st from './Subcategories.module.css';

type SubcategoriesProps = {
  subcategory?: any;
  category: {
    id: string;
    name: string;
  };
  subcategories: [any];
  onSubcategorySelect: () => void;
  onCategoryReset: () => void;
};

const Subcategories: FC<SubcategoriesProps> = ({
  category,
  subcategory = null,
  subcategories,
  onSubcategorySelect,
  onCategoryReset,
}) => (
  <div className={cn(st.subcategories, 'scroll')}>
    <BackButton onClick={onCategoryReset} text={category.name} />
    <CategoriesList
      buttonTestId="catalogSubcategoryButton"
      onCategorySelect={onSubcategorySelect}
      categories={subcategories}
      category={subcategory}
      viewType={CATEGORY_LIST_VIEW_TYPES.SUBCATEGORY}
    />
  </div>
);

export default Subcategories;
